import { Link as MuiLink, TypographyOwnProps, useTheme } from '@mui/material';
import { Link as ReactRouterLink, To } from 'react-router-dom';

interface RouterLinkProps {
	to: To;
	underline?: 'always' | 'none' | 'hover';
	variant?: TypographyOwnProps['variant'];
	color?: string;
	children: React.ReactElement | string;
}

const RouterLink = ({
	to,
	underline = 'always',
	variant = 'label',
	color,
	children,
}: RouterLinkProps) => {
	const { palette } = useTheme();
	const textColor = color ?? palette.textPrimary.main;
	return (
		<MuiLink
			component={ReactRouterLink}
			to={to}
			variant={variant}
			underline='none'
			color={textColor}
			sx={{
				display: 'inline-flex',
				alignItems: 'center',
				borderBottom: `1px solid ${underline == 'hover' ? 'transparent' : textColor}`,
				'&:hover': {
					borderBottom: `1px solid ${underline == 'none' ? 'transparent' : textColor}`,
					textDecoration: 'none',
				},
			}}
		>
			{children}
		</MuiLink>
	);
};

export default RouterLink;
